import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeApiRequest } from "../../helpers";
import { ApiResponse } from "../../api/apiResponse";
import { addSessionCommentData } from "../../api/endpoints/supervisors/sessions";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";

type AddCommentPropsType = {
  refetch: any;
};

export default function AddComment(props: AddCommentPropsType) {
  const { refetch } = props;
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { id } = useParams();
  const [comment, setComment] = useState<string>("");
  const { currentUser }: any = useAuth();

  const addSessionComment = (data: string,isVisible: boolean) => {
    makeApiRequest(
      () => addSessionCommentData(id ?? "", data,isVisible),
      (res: ApiResponse) => {
        if (res.isSuccess) {
          refetch();
          setComment("");
        }
      }
    );
  };
  return (
    <div className="flex items-start  gap-3 border-b border-gray-300 pb-3">
      <div className="flex-shrink-0">
        <UserProfilePictureAvatar
          className="inline-block h-10 w-10 rounded-full"
          profilePictureUrl={currentUser?.profile_picture_url}
          alt=""
        />
      </div>
      <div className="min-w-0 flex-1">
        <form>
          <div className="">
            <textarea
              rows={2}
              name="comment"
              id="comment"
              className="block text-sm w-full resize-none rounded-md border border-gray-300 px-3 text-gray-500 placeholder:text-gray-500"
              value={comment}
              placeholder={t("addComment")}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
          <div className="flex justify-end pt-3">
            <div className="flex-shrink-0 flex gap-2 items-center">
              <button
                className="inline-flex items-center border border-gray-300 rounded-md bg-transparent px-3 py-2 text-base font-medium text-gray-700 shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandblue-100"
                onClick={(e) => {
                  e.preventDefault();
                  addSessionComment(comment,false);
                }}
              >
                {t("save")}
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  addSessionComment(comment,true);
                }}
                className="inline-flex items-center rounded-md bg-brandblue-600 px-3 py-2 text-base font-medium text-white shadow-sm hover:bg-brandblue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandblue-600"
              >
                {t("saveAndSend")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
